import { Components } from "@mui/material";

export const MuiDialog: Components["MuiDialog"] = {
  styleOverrides: {
    root: {
      paddingTop: "var(--safe-area-inset-top)",
      paddingBottom: "var(--safe-area-inset-bottom)",
    },
  },
};
